import Chip from "../../../../common/chip/Chip"

const badgeVariant = {
  Paid: ['secondary', false],
  Unpaid: ['secondary--outlined', true],
  Other: ['primary--outlined', true],
  Active: ['success', false],
  Inactive: ['default', false]
}

export const getBadgeProps = (key, fallback = 'Other') => {
  const [variant, outline] = badgeVariant[key] || badgeVariant[fallback]
  return { variant, ...(outline && { outline: true }) }
}

export const getEventListColumns = (integrationMode, t) => {
  const isProcountor = integrationMode === 'PROCOUNTOR'
  const isNoIntegration = integrationMode === 'NOINTEGRATION'
  const isEsalary = integrationMode === 'ESALARY'

  return [
      {
        headerName: t('Event'),
        field: 'eventTypeLabel',
        filter: 'agTextColumnFilter',
        editable: false,
        flex: 1
      },
      {
        headerName: t('SalaryType'),
        field: 'salaryTypeCode',
        editable: isNoIntegration || isEsalary,
        singleClickEdit: true,
        filter: 'agTextColumnFilter',
        flex: 1,
        hide: isProcountor
      },
      {
        headerName: t('payStatus'),
        field: 'payStatus',
        editable: false,
        cellRenderer: params => {
          const salaryBadge = getBadgeProps(params.value)
          return (
          <Chip
            variant={salaryBadge.variant}
            data-testid={`pay-status-chip-${params.value || 'other'}`}
          >
            {t(params.value)}
          </Chip>
        )},
        flex: 1
      },
      {
        headerName: t('useStatus'),
        field: 'status',
        editable: !isProcountor,
        cellRenderer: params => {
          const statusBadge = getBadgeProps(params.value ? 'Active' : 'Inactive')
          return (
            <Chip
              variant={statusBadge.variant}
              data-testid={`use-status-chip-${params.value ? 'active' : 'inactive'}`}
            >
              {t(params.value ? 'Active' : 'Inactive', params.value ? 'Aktiivinen' : 'Ei aktiivinen')}
            </Chip>
        )},
        cellEditor: 'agSelectCellEditor',
        singleClickEdit: true,
        cellEditorParams: {
          values: [true, false],
          formatValue: (value) => value ? t('Active', 'Aktiivinen') : t('Inactive', 'Ei aktiivinen')
        },
        valueFormatter: params => params.value ? t('Active', 'Aktiivinen') : t('Inactive', 'Ei aktiivinen'),
        filter: 'agSetColumnFilter',
        flex: 1
      }
    ]
}